import {
  AfterViewChecked,
  Directive,
  ElementRef,
  Input,
  OnInit
} from '@angular/core';

@Directive({
  selector: '[appGenderRender]',
  standalone: false
})
export class GenderRenderDirective implements AfterViewChecked {
  _zuUngunstenFrauen: boolean;
  _gesamtscore: number;
  style = 'margin-right:2px !important; margin-left:2px !important;';

  @Input() set zuUngunstenFrauen(value: boolean) {
    this._zuUngunstenFrauen = value;
  }
  @Input() set gesamtscore(value: number) {
    this._gesamtscore = value;
  }
  constructor(private readonly el: ElementRef) {}

  ngAfterViewChecked(): void {
    if (
      this._zuUngunstenFrauen === null ||
      this._zuUngunstenFrauen === undefined
    ) {
      this.el.nativeElement.innerHTML = `<span>${this._gesamtscore}</span>`;
    }

    if (this._zuUngunstenFrauen) {
      // eslint-disable-next-line max-len
      this.el.nativeElement.innerHTML = `<span>${this._gesamtscore}</span>&nbsp;(<span style="${this.style}" class="fa fa-venus fa-lg"></span>)`;
    } else {
      this.el.nativeElement.innerHTML = `<span>${this._gesamtscore}</span>&nbsp;(<span style="${this.style}" class="fa fa-mars fa-lg"></span>)`;
    }
  }
}
